import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, TextInput, Label } from "flowbite-react";
import Button_submit from "../components/Button_submit";
import axios from "axios";
import GlobalContext from '../connections/GlobalContext';
import Swal from "sweetalert2";
import Head_data from "../components/Head_data";
import DataTable from "react-data-table-component";
import engineGif from "../image/engine.gif";

const Insurance = () => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("add");
  const [companyName, setCompanyName] = useState("");
  const [gstList, setGstList] = useState([{ gstName: "", gstNo: "" }]); 
  const [error, setError] = useState("");
  const [gstErrors, setGstErrors] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [id, setId] = useState(null);
  const { globalValue } = useContext(GlobalContext);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState(companies);
  const [show1, setShow1] = useState(false);
  const [b_details, setB_details] = useState([]);
  const [branchName, setBranchName] = useState("");
  const [branchMobile, setBranchMobile] = useState("");
  const [branchEmail, setBranchEmail] = useState("");
  const [branchCode, setBranchCode] = useState("");
  const [currentCompanyId, setCurrentCompanyId] = useState(null);

  const [branchMode, setBranchMode] = useState("add");
  const [originalBranchName, setOriginalBranchName] = useState(null);

  const [branchErrors, setBranchErrors] = useState({
    name: "",
    mobile: "",
    email: "",
    code: "",
  });

  useEffect(() => {
    const filteredData = companies.filter((branch) =>
      branch[2].toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFiltered(filteredData);
  }, [searchTerm, companies]);

  const fetchData = () => {
    setLoading(true);
    fetch(globalValue + "/insurance", {
      method: "GET",
      headers: { 'x-access-token': sessionStorage.getItem('token') }
    })
      .then((res) => res.json())
      .then((data) => {
        setCompanies(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    setCompanyName(e.target.value);
    setError(""); 
  };

  const addGstEntry = () => {
    setGstList([...gstList, { gstName: "", gstNo: "" }]);
    setGstErrors([...gstErrors, { gstName: "", gstNo: "" }]);
  };

  const removeGstEntry = (index) => {
    const newList = gstList.filter((_, i) => i !== index);
    const newErrors = gstErrors.filter((_, i) => i !== index);
    setGstList(newList);
    setGstErrors(newErrors);
  };

  const handleGstEntryChange = (index, field, value) => {
    const newList = [...gstList];
    newList[index][field] = value;
    setGstList(newList);
    
    const newErrors = [...gstErrors];
    newErrors[index] = { ...newErrors[index], [field]: "" };
    setGstErrors(newErrors);
  };

  const clearBranchForm = () => {
    setBranchName("");
    setBranchMobile("");
    setBranchEmail("");
    setBranchCode("");
    setBranchErrors({});
    setBranchMode("add");
    setOriginalBranchName(null);
  };


  const validateGst = (gst) => {
    const gstFormat = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/i;
    return gstFormat.test(gst.trim());
  };


  const validateCompanyForm = () => {
    let valid = true;
    if (companyName.trim() === "") {
      setError("Insurance company name is required.");
      valid = false;
    } else {
      setError("");
    }

    // Validate only GST entries that have at least one field filled
    const errors = gstList.map(entry => {
      const err = { gstName: "", gstNo: "" };
      const hasName = entry.gstName.trim() !== "";
      const hasNo = entry.gstNo.trim() !== "";

      if (hasName || hasNo) {
        if (!hasName) {
          err.gstName = "GST name is required if GST number is provided.";
          valid = false;
        } else if (hasNo && !validateGst(entry.gstNo)) {
          err.gstNo = "Invalid GST No format.";
          valid = false;
        }
      }
      
      return err;
    });
    
    setGstErrors(errors);

    return valid;
  };

  const handleSubmit = async () => {
    if (!validateCompanyForm()) return;

    // Filter out completely empty GST entries
    const filteredGstList = gstList.filter(entry => entry.gstName.trim() || entry.gstNo.trim());

    // Check for GST entries with name but no number
    const hasGstWithMissingNo = filteredGstList.some(entry => entry.gstName.trim() && !entry.gstNo.trim());
    if (hasGstWithMissingNo) {
      const result = await Swal.fire({
        icon: "warning",
        title: "Warning!",
        text: "One or more GST entries have a name but no number. Do you want to proceed?",
        showCancelButton: true,
        confirmButtonText: "Yes, proceed",
        cancelButtonText: "No, go back"
      });
      if (!result.isConfirmed) return;
    }

    setLoading(true);
    try {
      const url = mode === "add" ? `${globalValue}/insurance_add` : `${globalValue}/insurance_edit`;
      const payload = mode === "add"
        ? { companyName, gstList: filteredGstList }
        : { id, companyName, gstList: filteredGstList };
      const response = await axios.post(url, payload, {
        headers: { 'x-access-token': sessionStorage.getItem('token') }
      });
      if (response.data === "success") {
        Swal.fire({ icon: "success", title: "Success!", text: mode === "add" ? "Company added successfully" : "Company updated successfully" });
        setOpen(false);
        setCompanyName("");
        setGstList([{ gstName: "", gstNo: "" }]);
        setGstErrors([]);
        fetchData();
      }
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error!", text: err.response?.data?.error || "Something went wrong!" });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        const response = await axios.post(`${globalValue}/insurance_delete`, { id }, {
          headers: { 'x-access-token': sessionStorage.getItem('token') }
        });
        if (response.data === "success") {
          Swal.fire({ icon: "success", title: "Deleted!", text: "Insurance company deleted successfully." });
          fetchData();
        }
      }
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error!", text: err.response?.data?.error || "Something went wrong!" });
    } finally {
      setLoading(false);
    }
  };

  const handleBranchDelete = async (branch) => {
    const result = await Swal.fire({
      title: "Delete branch?",
      text: `Are you sure you want to delete '${branch.branch}'?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });
    if (!result.isConfirmed || !currentCompanyId) return;

    try {
      setLoading(true);
      const response = await axios.post(`${globalValue}/insurance_branch_delete`, {
        company_id: currentCompanyId,
        branch: branch.branch
      }, {
        headers: { 'x-access-token': sessionStorage.getItem('token') }
      });

      if (response.data.success === 1) {
        Swal.fire({ icon: "success", title: "Deleted!", text: response.data.message });
        setB_details(prev => prev.filter(b => b.branch !== branch.branch));
        setShow1(false);
        fetchData();
      } else {
        Swal.fire({ icon: "error", title: "Error!", text: response.data.message });
      }
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error!", text: err.message });
    } finally {
      setLoading(false);
    }
  };

  const validateBranch = () => {
    const errors = {};
    if (!branchName.trim()) errors.name = "Branch name is required.";
    if (branchMobile.trim() && !/^\d{10}$/.test(branchMobile)) {
      errors.mobile = "Mobile number must be 10 digits.";
    }
    if (branchEmail.trim() && !/\S+@\S+\.\S+/.test(branchEmail)) {
      errors.email = "Email address is invalid.";
    }
    // Branch code is optional, no validation required

    setBranchErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleBranchAdd = async () => {
    if (!validateBranch() || !currentCompanyId) return;

    setLoading(true);
    try {
      const response = await axios.post(`${globalValue}/insurance_branch_add`, {
        company_id: currentCompanyId,
        branch: branchName,
        mobile: branchMobile,
        address: branchEmail,
        branch_code: branchCode
      }, {
        headers: { 'x-access-token': sessionStorage.getItem('token') }
      });

      if (response.data.success === 1) {
        Swal.fire({ icon: "success", title: "Added!", text: response.data.message });
        fetchData(); 
        setShow1(false); 
        clearBranchForm();
      } else {
        Swal.fire({ icon: "error", title: "Error!", text: response.data.message });
      }
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error!", text: err.message });
    } finally {
      setLoading(false);
    }
  };

  const handleBranchUpdate = async () => {
    if (!validateBranch() || !currentCompanyId || !originalBranchName) return;

    setLoading(true);
    try {
      const response = await axios.post(`${globalValue}/insurance_branch_edit`, {
        company_id: currentCompanyId,
        original_branch_name: originalBranchName,
        branch: branchName,
        mobile: branchMobile,
        address: branchEmail,
        branch_code: branchCode
      }, {
        headers: { 'x-access-token': sessionStorage.getItem('token') }
      });

      if (response.data.success === 1) {
        Swal.fire({ icon: "success", title: "Updated!", text: response.data.message });
        fetchData();
        setShow1(false);
        clearBranchForm();
      } else {
        Swal.fire({ icon: "error", title: "Error!", text: response.data.message });
      }
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error!", text: err.message });
    } finally {
      setLoading(false);
    }
  };

  const handleBranchEditClick = (branch) => {
    setBranchMode('edit');
    setOriginalBranchName(branch.branch);
    setBranchName(branch.branch);
    setBranchMobile(branch.mobile);
    setBranchEmail(branch.address);
    setBranchCode(branch.branch_code);
  };

  // Table columns: index 1 = ID, index 2 = Name, index 4 = GST list
  const columns = [
    { name: "Insurance Company ID", selector: row => row[1] },
    { name: "Insurance Company Name", selector: row => row[2] },
    { 
      name: "GST Details", 
      selector: row => {
        if (Array.isArray(row[4])) {
          return row[4].map(gst => `${gst.gstName}: ${gst.gstNo}`).join(", ");
        }
        return row[4] || "";
      }
    },
    {
      name: "Actions",
      center: true,
      cell: (row) => (
        <div className="flex gap-4">
          <button className="p-2 text-white border bg-blue-700 hover:bg-blue-800 rounded-md shadow-xl" onClick={() => { setShow1(true); setB_details(row[3] || []); setCurrentCompanyId(row[1]); }}>
            <i className="fa fa-eye"></i>
          </button>
          <button onClick={() => { 
            setMode("edit"); 
            setCompanyName(row[2]); 
            setGstList(row[4] || [{ gstName: "", gstNo: "" }]);
            setGstErrors([]);
            setId(row[1]); 
            setOpen(true); 
          }} className="p-2 text-white bg-blue-600 rounded-md hover:bg-blue-700">
            <i className="fa fa-edit"></i>
          </button>
          <button onClick={() => handleDelete(row[1])} className="p-2 text-white bg-red-600 rounded-md hover:bg-red-700">
            <i className="fa fa-trash"></i>
          </button>
        </div>
      )
    }
  ];

  const customStyles = {
    table: { style: { backgroundColor: 'white', width: '100%', border: "solid 1px rgb(226, 232, 240)" } },
    headCells: { style: { backgroundColor: 'rgb(226, 232, 240)', color: 'black', fontWeight: 'bold' } }
  };

  return (<>
    <div className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] mt-16 h-[92vh] flex justify-center items-center box-border`}>
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
          <img src={engineGif} alt="Loading..." className="w-24 h-24" />
        </div>
      )}
      <div className="w-[95%] md:w-[98%] h-[95%] bg-white px-4 py-2 rounded-xl shadow-xl overflow-auto">
        <div className="w-full flex justify-between items-center text-gray-600">
          <Head_data data="Manage Insurance Companies" font="" size="3xl" />
          <button onClick={() => { setMode("add"); setCompanyName(""); setGstList([{ gstName: "", gstNo: "" }]); setGstErrors([]); setOpen(true); }} className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 md:mt-2">
            Add Insurance
          </button>
        </div>
        <input type="text" placeholder="Search by insurance name" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full md:w-1/3 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200" />
        <div className="py-6 md:px-4">
          <DataTable columns={columns} data={filtered} customStyles={customStyles} pagination />
        </div>
      </div>
    </div>

    <Modal show={show1} onClose={() => { setShow1(false); clearBranchForm(); }} size="6xl">
      <Modal.Header className="flowbite-modal-h">Branch Details</Modal.Header>
      <Modal.Body className="flowbite-modal-b">
        <div className="flex flex-col gap-4 mb-4 p-4 border rounded-lg">
          <h3 className="text-xl font-semibold text-gray-700">{branchMode === 'add' ? 'Add a New Branch' : 'Edit Branch'}</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label htmlFor="branchName" value="Branch Name" />
              <TextInput id="branchName" placeholder="Main Branch" value={branchName} onChange={(e) => { setBranchName(e.target.value); setBranchErrors({ ...branchErrors, name: '' }) }} />
              {branchErrors.name && <p className="text-red-500 text-sm mt-1">{branchErrors.name}</p>}
            </div>
            <div>
              <Label htmlFor="branchMobile" value="Mobile (10 digits)" />
              <TextInput id="branchMobile" type="tel" maxLength="10" placeholder="9876543210" value={branchMobile} onChange={(e) => { setBranchMobile(e.target.value); setBranchErrors({ ...branchErrors, mobile: '' }) }} />
              {branchErrors.mobile && <p className="text-red-500 text-sm mt-1">{branchErrors.mobile}</p>}
            </div>
            <div>
              <Label htmlFor="branchEmail" value="Email" />
              <TextInput id="branchEmail" type="email" placeholder="branch@example.com" value={branchEmail} onChange={(e) => { setBranchEmail(e.target.value); setBranchErrors({ ...branchErrors, email: '' }) }} />
              {branchErrors.email && <p className="text-red-500 text-sm mt-1">{branchErrors.email}</p>}
            </div>
            <div>
              <Label htmlFor="branchCode" value="Branch Code" />
              <TextInput id="branchCode" placeholder="BRN123" value={branchCode} onChange={(e) => { setBranchCode(e.target.value); setBranchErrors({ ...branchErrors, code: '' }) }} />
              {branchErrors.code && <p className="text-red-500 text-sm mt-1">{branchErrors.code}</p>}
            </div>
          </div>
          <div className="flex gap-4">
            <Button onClick={branchMode === 'add' ? handleBranchAdd : handleBranchUpdate} className="w-max bg-blue-600 hover:bg-blue-700 text-white">
              {branchMode === 'add' ? 'Add Branch' : 'Update Branch'}
            </Button>
            {branchMode === 'edit' && (
              <Button onClick={clearBranchForm} className="w-max bg-gray-500 hover:bg-gray-600 text-white">
                Cancel Edit
              </Button>
            )}
          </div>
        </div>
        <div className="overflow-auto mt-6">
          <table className="w-full border-collapse border border-gray-300">
            <thead className="bg-gray-200">
              <tr>
                <th className="border border-gray-300 px-4 py-2 text-left">Branch</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Mobile</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Email</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Branch Code</th>
                <th className="border border-gray-300 px-4 py-2 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {(b_details && b_details.length > 0) ? (
                b_details.map((branch, index) => (
                  <tr key={index} className="hover:bg-gray-100">
                    <td className="border border-gray-300 px-4 py-2">{branch.branch}</td>
                    <td className="border border-gray-300 px-4 py-2">{branch.mobile}</td>
                    <td className="border border-gray-300 px-4 py-2">{branch.address}</td>
                    <td className="border border-gray-300 px-4 py-2">{branch.branch_code}</td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      <div className="flex gap-2 justify-center">
                        <button className="p-2 text-white bg-blue-600 hover:bg-blue-700 rounded-md shadow-md" onClick={() => handleBranchEditClick(branch)}>
                          <i className="fa fa-edit"></i>
                        </button>
                        <button className="p-2 text-white bg-red-600 hover:bg-red-700 rounded-md shadow-md" onClick={() => handleBranchDelete(branch)}>
                          <i className="fa fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center border border-gray-300 px-4 py-2">
                    No branch details available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>

    <Modal show={open} onClose={() => setOpen(false)}>
      <Modal.Header className="flowbite-modal-h">
        {mode === "add" ? "Add Insurance Company" : "Edit Insurance Company"}
      </Modal.Header>
      <Modal.Body className="flowbite-modal-b">
        <div className="mb-4">
          <Label htmlFor="companyName" value="Company Name" />
          <TextInput id="companyName" name="companyName" placeholder="Enter company name" value={companyName} onChange={handleInputChange} color={error ? "failure" : "white"} required />
          {error && <p className="text-sm text-red-600">{error}</p>}
        </div>
        
        <div className="mb-4">
          <div className="flex justify-between items-center mb-2">
            <Label value="GST Details" />
            <button 
              onClick={addGstEntry}
              className="px-3 py-1 text-sm text-white bg-green-600 rounded hover:bg-green-700"
            >
              <i className="fa fa-plus mr-1"></i> Add GST
            </button>
          </div>
          
          {gstList.map((entry, index) => (
            <div key={index} className="mb-3 p-3 border border-gray-200 rounded-lg">
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm font-medium text-gray-700">GST Entry {index + 1}</span>
                {gstList.length > 1 && (
                  <button 
                    onClick={() => removeGstEntry(index)}
                    className="text-red-600 hover:text-red-700"
                  >
                    <i className="fa fa-trash"></i>
                  </button>
                )}
              </div>
              
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Label value="GST Name" />
                  <TextInput 
                    placeholder="e.g., CGST" 
                    value={entry.gstName} 
                    onChange={(e) => handleGstEntryChange(index, "gstName", e.target.value)} 
                    color={gstErrors[index]?.gstName ? "failure" : "white"} 
                  />
                  {gstErrors[index]?.gstName && <p className="text-xs text-red-600 mt-1">{gstErrors[index].gstName}</p>}
                </div>
                <div>
                  <Label value="GST Number" />
                  <TextInput 
                    placeholder="Enter GST Number" 
                    value={entry.gstNo} 
                    onChange={(e) => handleGstEntryChange(index, "gstNo", e.target.value)} 
                    maxLength="15"
                    color={gstErrors[index]?.gstNo ? "failure" : "white"} 
                  />
                  {gstErrors[index]?.gstNo && <p className="text-xs text-red-600 mt-1">{gstErrors[index].gstNo}</p>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className="flowbite-modal-b">
        <Button_submit onClick={handleSubmit} data={mode === "add" ? "Submit" : "Update"} type="submit" aditional="ms-auto" />
      </Modal.Footer>
    </Modal>
  </>);
};

export default Insurance;
